export default {
    register: { method: 'post', url: 'v1/movida/ambiente/register' },
    delete: { method: 'post', url: 'v1/movida/ambiente/delete' },
}